import { Stack, useTheme } from "@mui/material";
import { Typography } from "@foodpilot/foods";
import type { AuditLogEntry } from "src/api/client-api/auditLog/auditLogSchemas";
import { ActionDot } from "./ActionIndicator";
import { auditLogSubject } from "./auditLogPresentation";
import { useAuditLogLabels } from "./useAuditLogLabels";

type AuditLogObjectLabelProps = {
    entry: AuditLogEntry;
};

export const AuditLogObjectLabel = (props: AuditLogObjectLabelProps) => {
    const { entry } = props;
    const theme = useTheme();
    const labels = useAuditLogLabels();
    const typeLabel = labels.entityType(entry.entityType);
    const subject = auditLogSubject(entry);
    const relation = labels.recipientPhrase(entry) ?? (subject === null ? null : typeLabel);

    return (
        <Stack direction="row" gap={theme.spacing(1)} alignItems="center" overflow="hidden">
            <ActionDot action={entry.action} />
            <Typography variant="small-semibold" noWrap>
                {subject ?? typeLabel}
            </Typography>
            {relation !== null && (
                <Typography variant="small-regular" color="text.secondary" noWrap>
                    {relation}
                </Typography>
            )}
        </Stack>
    );
};
